import React from "react";
import "../../../HomePage/AskedQuestion/NewAskedQuestion.css";

const CustomSoftwareDevFaq = () => {
  return (
    <div id="f&q">
      <div
        id="faq"
        style={{ zIndex: 2, background: "#FAFAFA" }}
        className="faq-section position-relative"
      >
        <div className="faq-box p-4 p-md-5 rounded-3">
          <div className="text-center mb-4 mb-md-5">
            <h2 className="fw-semibold Tech-heading  display-6">
              Questions People Ask Before Starting
            </h2>
            <p className="text-muted database-text mb-0">
              A few honest answers to things clients tend to ask once they start
              considering custom software development seriously.
            </p>
          </div>

          <div className="row">
            <div className="col-12 col-lg-10 mx-auto">
              <div className="accordion custom-accordion" id="faqAccordion">
                {/* FAQ 1 */}
                <div className="accordion-item faq-item">
                  <h2 className="accordion-header " id="faqHeadingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqCollapseOne"
                      aria-expanded="true"
                      aria-controls="faqCollapseOne"
                    >
                      <span className="faq-num me-4 fw-semibold three">01</span>
                      <span className="faq-question  fqa-heading">
                        How is custom software development different from using
                        off the shelf tools?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="faqCollapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="faqHeadingOne"
                    data-bs-parent="#faqAccordion"
                  >
                    <div
                      className="accordion-body small fqa-text text-muted px-3 px-md-5 ms-5 "
                      style={{ textAlign: "justify", maxWidth: "85%" }}
                    >
                      Off the shelf tools force your business to adapt. Custom
                      software is made according to how your team already works,
                      so processes feel natural rather than restrictive.
                    </div>
                  </div>
                </div>

                {/* FAQ 2 */}
                <div className="accordion-item faq-item">
                  <h2 className="accordion-header" id="faqHeadingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqCollapseTwo"
                      aria-expanded="false"
                      aria-controls="faqCollapseTwo"
                    >
                      <span className="faq-num me-4 fw-semibold three">02</span>
                      <span className="faq-question  fqa-heading">
                        Why choose offshore custom software development with
                        Quad Theory Ltd?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="faqCollapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="faqHeadingTwo"
                    data-bs-parent="#faqAccordion"
                  >
                    <div
                      className="accordion-body fqa-text small text-muted px-3 px-md-5 ms-5"
                      style={{ textAlign: "justify", maxWidth: "85%" }}
                    >
                      Clients come to us for offshore software development in
                      Bangladesh because they want to have stable teams, clear
                      communication and a long term ownership instead of short
                      term delivery.
                    </div>
                  </div>
                </div>

                {/* FAQ 3 */}
                <div className="accordion-item faq-item">
                  <h2 className="accordion-header" id="faqHeadingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqCollapseThree"
                      aria-expanded="false"
                      aria-controls="faqCollapseThree"
                    >
                      <span className="faq-num me-4 fw-semibold three">03</span>
                      <span className="faq-question fqa-heading ">
                        How involved do we need to be during development?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="faqCollapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="faqHeadingThree"
                    data-bs-parent="#faqAccordion"
                  >
                    <div
                      className="accordion-body fqa-text small text-muted px-3 ms-5 px-md-5"
                      style={{ textAlign: "justify", maxWidth: "85%" }}
                    >
                      You are involved where it makes a difference. We
                      facilitate the process, ask the right questions, and keep
                      feedback simple so that decision making is never
                      overwhelming or time consuming.
                    </div>
                  </div>
                </div>

                {/* FAQ 4 */}
                <div className="accordion-item faq-item">
                  <h2 className="accordion-header" id="faqHeadingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqCollapseFour"
                      aria-expanded="false"
                      aria-controls="faqCollapseFour"
                    >
                      <span className="faq-num me-4 fw-semibold three">04</span>
                      <span className="faq-question  fqa-heading">
                        Can you work with existing systems and legacy software?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="faqCollapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="faqHeadingFour"
                    data-bs-parent="#faqAccordion"
                  >
                    <div
                      className="accordion-body fqa-text small text-muted px-3 ms-5 px-md-5"
                      style={{ textAlign: "justify", maxWidth: "85%" }}
                    >
                      Yes. Many projects are related to improvements or
                      replacements of old systems. We carefully consider what to
                      preserve and what to reconstruct, as well as the need to
                      avoid interfering with daily operations.
                    </div>
                  </div>
                </div>

                {/* FAQ 5 */}
                <div className="accordion-item faq-item">
                  <h2 className="accordion-header" id="faqHeadingFive">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqCollapseFive"
                      aria-expanded="false"
                      aria-controls="faqCollapseFive"
                    >
                      <span className="faq-num me-4 fw-semibold  three">
                        05
                      </span>
                      <span className="faq-question fqa-heading">
                        What happens after the software is launched?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="faqCollapseFive"
                    className="accordion-collapse collapse"
                    aria-labelledby="faqHeadingFive"
                    data-bs-parent="#faqAccordion"
                  >
                    <div
                      className="accordion-body small fqa-text text-muted ms-5 px-3 px-md-5"
                      style={{ textAlign: "justify", maxWidth: "85%" }}
                    >
                      Launch is not the end. We are continuing to support,
                      improve and refine the software as real users interact
                      with it and new business needs emerge.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomSoftwareDevFaq;
